import { Box, Grid, Skeleton, useTheme, useMediaQuery } from '@mui/material';
import { sxStyled } from './styles';

const FiltersSkeleton = () => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  // Breakpoints reales de MUI
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      container
      item
      xs={12}
      md={3}
      sx={{
        ...sxStyle.root,
        ...(isDesktop && {
          // Desktop: mantiene estilo de tu render normal
          padding: '20px',
          margin: '30px',
          border: '1px solid #E5E5E5',
          boxShadow: '0px 4px 20px 0px #e3e3e3',
        }),
      }}
    >
      {/* HEADER */}
      <Grid item container sx={sxStyle.filterTitleContainer}>
        <Skeleton variant="text" height={30} width={90} />
        <Skeleton variant="text" height={25} width={70} />
      </Grid>

      <Grid sx={sxStyle.filterBoxContainer} item>
        {[1, 2, 3, 4, 5].map(i => (
          <Grid key={i} item xs={12} sx={sxStyle.filterBox}>
            <Skeleton variant="text" height={30} width={90} />

            <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
              <Skeleton variant="rectangular" height={40} />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
              <Skeleton variant="rectangular" height={40} width={'80%'} />
            </Box>
          </Grid>
        ))}

        {/* Solo en mobile */}
        {isMobile && (
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Skeleton variant="rectangular" height={40} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default FiltersSkeleton;
